import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Link } from '@ui/components/Link'
import { Modal } from '@ui/components/Modal'

import { useCopy } from '@hooks/useCopy'
import { useIBLink } from '@hooks/useIBLink'

interface Props {
  ibCode?: string
  mtCode?: string
  isMt?: boolean
}

export const HowIBWorksModal: BaseModalType<Props> = (props) => {
  const { t } = useTranslation()
  const { close, isMt, ibCode, mtCode } = props
  const { ibLink, mtLink } = useIBLink(ibCode, mtCode)
  const { copy } = useCopy()

  const title = isMt ? `${t('IB.MultiTier.How Multi-tier works')}?` : t('IB.How IB works?')
  const introducingBrokerCode = isMt ? mtCode : ibCode
  const introducingBrokerReferralLink = isMt ? mtLink : ibLink

  return (
    <Modal>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Modal.Body.TitleTextBox>
          <Modal.Body.Title>1.</Modal.Body.Title>
          <Modal.Body.Text>
            {introducingBrokerReferralLink ? (
              <Link
                underline={false}
                size='lg'
                onClick={() => copy(introducingBrokerReferralLink, t('Copied to Clipboard!'))}
              >
                {t('Profile.Copy your URL')}
              </Link>
            ) : (
              <span>{t('Profile.Copy your URL')}</span>
            )}{' '}
            {t(
              'Profile.and share it with your network. Every trader who registers with Tickmill via your link is automatically counted as your invitee.  '
            )}
          </Modal.Body.Text>
        </Modal.Body.TitleTextBox>

        <Modal.Body.TitleTextBox>
          <Modal.Body.Title>2.</Modal.Body.Title>
          <Modal.Body.Text>
            {t('Profile.Pass your unique Referral Code')}{' '}
            <Link
              underline={false}
              size='lg'
              onClick={() => copy(introducingBrokerCode, t('Copied to Clipboard!'))}
            >
              {introducingBrokerCode}
            </Link>{' '}
            {t(
              'Profile.to your invitee and ask them to submit it when filling in their personal details during registration.'
            )}
          </Modal.Body.Text>
        </Modal.Body.TitleTextBox>

        <Modal.Body.TitleTextBox>
          <Modal.Body.Title>3.</Modal.Body.Title>
          <Modal.Body.Text>
            {t(
              'Profile.Recommend your clients open an MT5 or Tickmill Trader Raw accounts with us and they’ll get a 5% discount on their commissions'
            )}
          </Modal.Body.Text>
        </Modal.Body.TitleTextBox>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
